export const Logo = ({ fill }: React.SVGProps<SVGPathElement>) => (
  <>
    <rect fill={fill} x="66" y="180" width="130" height="13" />
    <polygon fill={fill} points="65 149 130 53 196 149 100.5 149 108.5 136 170 136 130 79.5 82 149" />
  </>
);
